<template>
  <div class="offer-card" :class="{ square: isSquare }">
    <a
      :class="[{ 'forbidden-click': multiOfferClickable }, 'offer-card__link']"
      :href="hrefUrl"
      @click="openSearchBar()"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div class="offer-card__thumbnail">
        <OfferCardLabel
          v-if="content.discount"
          class="thumbnail-label"
        >
          {{ content.discount }}
        </OfferCardLabel>
        <img
          class="thumbnail-image"
          :src="content.mainImage.url + '?impolicy=Card'"
          :alt="content.mainImage.altText"
        />
        <div class="offer-card__body" :class="{ compact: isCompact }">
          <div class="body-title">
            <h3 class="max-lines" :class="isCompact ? 'max-lines-4' : 'max-lines-2'">
              {{ content.title }}
            </h3>
          </div>
          <p v-if="withDescription" class="max-lines max-lines-2 body-description">
            {{ content.cardSubtitle }}
          </p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import OfferCardLabel from '@/components/offers/OfferCardLabel'
import { getQueryParams } from '@/infrastructure/Utils'
import { multiOffersService } from '../../infrastructure/Factory'

export default {
  name: 'OfferCard',
  components: {
    OfferCardLabel
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    isSquare: {
      type: Boolean,
      required: false,
      default: false
    },
    withDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    isCompact: {
      type: Boolean,
      required: false,
      default: false
    },
    isFeaturedDeals: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    multiOfferClickable() {
      return this.content.type === 'multi' && !this.content.detailPageUrl
    },
    hrefUrl() {
      if (this.content.type === 'single' && !this.content.detailPageUrl) {
        return '#'
      } else {
        return this.redirectToMultiOffersPage()
      }
    }
  },
  methods: {
    openSearchBar() {
      if (this.hrefUrl === '#') {
        global.selectedHotel = {
          name: this.content.name || '',
          code: this.content.hotelCodes[0]
        }
        global.searchBarVue.$emit('open-searchbar-modal')
      }
    },
    redirectToMultiOffersPage() {
      const { startDate, endDate, city, country } = getQueryParams(window.location.search)
      const params = {
        countryCode: country?.length ? country : '',
        cityCode: city?.length ? city : '',
        checkInDate: startDate,
        checkOutDate: endDate
      }
      const urlPrefix = multiOffersService.multiOffersRedirect(params)
      return window.location.href.includes('localhost')
        ? '?landingType=multioffers&' + window.location.search.replace('?landingType=offers&', '')
        : this.content.detailPageUrl + urlPrefix
    }
  }
}
</script>

<style scoped lang="scss">
$box-shadow: rgba(0, 0, 0, 0.16) 12px 8px 20px;
$border-color: #dee2e6;
$image-height: 232.75px;
$text-color: black;

.forbidden-click {
  pointer-events: none;
  cursor: default;
}

.max-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  &-2 {
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  &-4 {
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }
}

.offer-card {
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: none;
  cursor: pointer;
  border: 1px solid $border-color;

  transition: all 0.3s;

  &.square {
    aspect-ratio: 1;
  }

  &:hover {
    box-shadow: $box-shadow;

    .thumbnail-image {
      transform: scale(1.1);
    }
  }

  &__link {
    color: $text-color;
  }

  &__thumbnail {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .thumbnail-label {
      margin: 2.5rem 1.5rem;
      z-index: zindex('z-10');
    }

    .thumbnail-image {
      flex-shrink: 0;
      width: 100%;
      object-fit: cover;
      height: $image-height;
      max-height: $image-height;
      min-height: $image-height;
      transition: all 0.3s;
    }
  }

  &__body {
    position: relative;
    z-index: zindex('z-1');
    flex: 1 1 auto;
    padding: 1.5rem;
    background-color: color('white');

    .body-title {
      display: flex;
      align-items: flex-end;

      h3 {
        margin-bottom: 1.5rem;
        font-size: 1.5em;
        font-weight: 600;
        line-height: 1.35;

        &.max-lines-2 {
          height: calc(1.35em * 2); // height == 2 lines of text
        }
        &.max-lines-4 {
          max-height: calc(1.35em * 4); // height == 4 lines of text
        }

        @media (max-width: media('mobile-l')) {
          font-size: 1.5rem;
        }
        @media (max-width: media('tablet-l')) {
          font-size: 1.75rem;
        }
      }
    }
    .body-description {
      margin: 0;
      font-size: 1em;
      line-height: 1.35;
      height: calc(1.35em * 2); // height == 2 lines of text
    }
  }

  &__body.compact {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: color('white');
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.6306897759103641) 60%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
  }
}

html[dir="rtl"] {
  .offer-card {
    &__content {
      text-align: right;
    }
  }
}
</style>
